import { useEffect, useState } from 'react';

import { getAppletsUrl } from '@cartwhl/common/utils';

export default function useAppletsUrl(): string | undefined {
  const [appletsUrl, setAppletsUrl] = useState<string>();

  useEffect(() => {
    setAppletsUrl(getAppletsUrl());
  }, []);

  return appletsUrl;
}
